import { z } from "zod";

export const createKeywordSchema = z.object({
  keyword: z
    .string()
    .min(2, "Keyword must be at least 2 characters")
    .max(100, "Keyword too long")
    .transform((val) => val.trim()),
});

export type CreateKeywordSchema = z.infer<typeof createKeywordSchema>;
